export default __webpack_public_path__ + "static/media/Pickaxe of the Ubah Kan.95da7aa6.jpg";